import { all, put, call, takeLatest, select } from 'redux-saga/effects';
import { fetchHealthBreakdownDataByEventLevelId } from '../routines/healthRoutines';
import envConfig from '../../config';
import { request } from '../../common/util/RestClient';
import { MAX_CACHING_TIME_FOR_HEALTH_BREAKDOWN_IN_SEC } from '../../pages/HealthManagement/HealthManagementConstants';
import { selectHealthSelector } from '../selectors/healthBreakdownSelector';

const HEALTH_MANAGEMENT_BASE_URL = `${envConfig.APIG_URL}health-management`;

function* fetchHealthBreakdownSaga({ payload }) {
  try {
    const { entityId, level } = payload;
    const time = new Date().getTime();

    const { health, healthB, lastCacheTime } = yield select(
      selectHealthSelector()
    );

    const lastCacheTimeById = healthB?.[level]
      ? healthB?.[level][entityId]?.lastCacheTime
      : lastCacheTime;
    const timeDiffInSec = (time - lastCacheTimeById) / 3600;
    if (
      (healthB?.[level]
        ? healthB?.[level][entityId]?.entityId === entityId
        : false) &&
      timeDiffInSec < MAX_CACHING_TIME_FOR_HEALTH_BREAKDOWN_IN_SEC
    ) {
      const data = {
        health,
        healthB: healthB?.[level][entityId],
        lastCacheTime,
        level,
        entityId,
      };
      yield put(fetchHealthBreakdownDataByEventLevelId.success(data));
    } else {
      const url = `${HEALTH_MANAGEMENT_BASE_URL}/scores/${entityId}/?level=${level}&detail=true`;
      const response = yield call(request, url);

      const data = {
        health: response.data,
        healthB: response.data,
        lastCacheTime: new Date().getTime(),
        level,
        entityId,
      };
      yield put(fetchHealthBreakdownDataByEventLevelId.success(data));
    }
  } catch (error) {
    yield put(fetchHealthBreakdownDataByEventLevelId.failure({ error }));
  }
}

export default function* root() {
  yield all([
    takeLatest(
      fetchHealthBreakdownDataByEventLevelId.TRIGGER,
      fetchHealthBreakdownSaga
    ),
  ]);
}
